<template>
  <div class="resident-info app-region blank-t-v blank-b-v blank-l-h blank-r-h"
       v-if="!isScan && !isReview">
    <a-form-model class="app-form"
                  ref="form"
                  :model="form"
                  :rules="rules"
                  :labelCol="$formLabelCol"
                  :wrapperCol="$formWrapperCol">
      <a-form-model-item label="照片"
                         prop="avatar">
        <div class="avatar">
          <dy-image :src="form.avatar"></dy-image>
        </div>
      </a-form-model-item>
      <a-form-model-item label="住户姓名"
                         prop="name">
        <a-input v-model="form.name"
                 placeholder="请输入住户姓名"
                 allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="身份证号"
                         prop="number">
        <a-input v-model="form.number"
                 placeholder="请输入身份证号"
                 allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="手机号"
                         prop="phone">
        <a-input v-model="form.phone"
                 placeholder="请输入手机号"
                 allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属房屋"
                         prop="house">
        <div>
          <a-button type="primary"
                    @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large"
                 closable
                 @close.prevent="delHouse(index)"
                 v-for="(value, index) in form.house"
                 :key="index">{{value.full_name}}</a-tag>
        </div>
      </a-form-model-item>
      <a-form-model-item label="入住时间"
                         prop="time">
        <a-date-picker v-model="form.time"
                       placeholder="请选择入住时间"
                       valueFormat="YYYY-MM-DD"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="房屋身份"
                         prop="identity">
        <a-radio-group v-model="form.identity">
          <a-radio :value="1">{{houseIdentityText(1)}}</a-radio>
          <a-radio :value="2">{{houseIdentityText(2)}}</a-radio>
          <a-radio :value="3">{{houseIdentityText(3)}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="住户标签"
                         prop="label">
        <a-select v-model="form.label"
                  placeholder="请选择住户标签"
                  mode="multiple">
          <a-select-option :value="value.id"
                           v-for="(value, index) in labelOptions"
                           :key="index">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary"
                    @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title"
             v-model="modal.show"
             @ok="confirmModal"
             destroy-on-close
             width="60%"
             centered>
      <tree-select v-model="modal.house"
                   :data="tree.data"
                   :params="tree.params"
                   :load-data="$houseTreeData"
                   @load="loadTreeSelectNode"></tree-select>
    </a-modal>
  </div>
  <div class="resident-info"
       v-else>
    <a-descriptions :column="1"
                    bordered
                    v-viewer>
      <a-descriptions-item label="照片">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="住户姓名">{{form.name}}</a-descriptions-item>
      <a-descriptions-item label="身份证号">{{form.number}}</a-descriptions-item>
      <a-descriptions-item label="手机号">{{form.phone}}</a-descriptions-item>
      <a-descriptions-item label="所属房屋">{{form.house.map(val => val.full_name).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="入住时间">{{form.time}}</a-descriptions-item>
      <a-descriptions-item label="房屋身份">{{houseIdentityText(form.identity)}}</a-descriptions-item>
      <a-descriptions-item label="住户标签">{{labelOptions.filter(val => form.label.indexOf(val.id) > -1).map(val => val.name).join('、')}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions v-if="isReview">
      <a-descriptions-item>
        <a-space>
          <a-button type="primary"
                    @click="review">审核通过</a-button>
          <a-button type="primary"
                    @click="overrule">驳回</a-button>
        </a-space>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import {
  houseIdentityText
} from '@/io/dict.js';
import ResidentService from '@/io/resident.js';
import LabelService from '@/io/label.js';

export default {
  name: 'ResidentInfo',
  props: {
    isScan: {
      type: Boolean,
      default: false
    },
    isReview: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default () {
        return this.$route.params.id * 1;
      }
    },
    communityId: {
      type: Number,
      default () {
        return this.$route.query.community_id * 1 || this.$getCookie('communityId') * 1;
      }
    }
  },
  data () {
    return {
      houseIdentityText,
      tree: {
        data: [],
        params: {
          children: 'children',
          title: 'name',
          key: '_id'
        }
      },
      modal: {
        title: '选择房屋',
        show: false,
        house: []
      },
      labelOptions: [],
      form: {
        avatar: require('../../assets/images/avatar.png'),
        name: null,
        number: null,
        phone: null,
        house: [],
        time: null,
        identity: [],
        label: [],
        type: null // 接口需要
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入住户姓名'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号'
          }
        ],
        house: [
          {
            required: true,
            message: '请选择房屋身份'
          }
        ],
        identity: [
          {
            required: true,
            message: '请选择房屋身份'
          }
        ]
      }
    }
  },
  watch: {
    id: {
      handler (newValue, oldValue) {
        this.initLabelData();
        this.initTreeData().then(() => {
          if (newValue) {
            this.initPage();
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    loadTreeSelectNode (data) {
      data.children.forEach(val => {
        this.$set(val, 'disabled', val.level <= 3);
      });
    },
    review () {
      let self = this;
      this.$confirm({
        title: `该成员${this.form.name}房屋身份为${houseIdentityText(this.form.identity)}`,
        content: '确认审核通过？',
        onOk () {
          ResidentService.review(self.id).then(() => {
            self.$message.success('审核通过');
            self.$emit('confirm');
          });
        }
      });
    },
    overrule () {
      ResidentService.overrule(this.id).then(() => {
        this.$emit('confirm');
      });
    },
    initTreeData () {
      return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 4]).then(res => {
        this.tree.data = res.map(val => {
          val.disabled = true;
          return val;
        })
      });
    },
    initLabelData () {
      return LabelService.list().then(res => {

        this.labelOptions = res;
      }).catch(err => { });
    },
    confirmModal () {
      this.modal.show = false;
      this.form.house = this.$createNewVariable(this.modal.house);
    },
    showModal () {
      this.modal.show = true;
      

      this.modal.house = this.$createNewVariable(this.form.house);

    },
    delHouse (index) {
      this.form.house.splice(index, 1);
    },
    initPage () {
      if (this.id) {
        ResidentService.info(this.id).then(res => {
          if (res.user_info && res.user_info.face_recognition) {
            this.form.avatar = res.user_info.face_recognition;
          }
          this.form.name = res.name;
          this.form.number = res.id_card;
          this.form.phone = res.mobile;
          this.form.house = res.owner_housing.map(val => {
            val[this.tree.params.title] = val.full_name;
            val._id = val.id;
            return val;
          });
          this.form.time = res.move_into_date;
          this.form.identity = res.identity.id;
          this.form.label = res.owner_tags.map(val => val.id);
          this.form.type = res.audit_type;
        }).catch(err => { });
      }
    },
    submit () {
      this.$beforeFormSubmit(this.$refs.form, () => {
        if (this.id) {
          ResidentService.edit(
            this.communityId,
            this.id,
            this.form.name,
            this.form.number,
            this.form.phone,
            this.form.house[0].id,
            this.form.time,
            this.form.identity,
            this.form.label,
            this.form.type
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.cancel();
            });
          }).catch(err => { });
        } else {
          ResidentService.add(
            this.communityId,
            this.form.name,
            this.form.number,
            this.form.phone,
            this.form.house[0].id,
            this.form.time,
            this.form.identity,
            this.form.label,
            this.form.type
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.cancel();
            });
          }).catch(err => { });
        }
      });
    },
    cancel () {
      this.$router.push({
        name: 'ResidentManage'
      });
    }
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 100px;
  height: 100px;
}
</style>